export type SiteNavLink = {
    name: string;
    url: string;
};

export const siteNavLinks: readonly SiteNavLink[] = [
    { name: "Docs", url: "/docs" },
    { name: "Components", url: "/docs/components" },
    { name: "Icons", url: "/docs/content/icons" },
    { name: "Examples", url: "/examples" },
    { name: "Themes", url: "/themes" },
];
